<template>
    <v-card class="e-practicaCarousel transparent elevation-0">
      <v-card-title>
         <p class="p-normal text-xs-left" v-html="loadedLessons.instructions_spanish"></p>
      </v-card-title>
      <v-card-text class="pt-0">
        <div class="px-3 mb-4" style="position: relative">
          <v-card class="radius e-practicaCarousel-card align-center d-flex e-elevation--4">
            <v-card-text class="py-4 px-4">
              <p class="e-description-middle text-xs-center mb-0" v-html="loadedLessons.exercise"></p>
            </v-card-text>
          </v-card>
          <div class="e-practicaCarousel-rate">
            <v-btn fab color="white grey-lightness--text" @click="seleccionarRespuesta(!correcto)" >
              <v-icon :class="correcto ? 'yellow--text' : 'grey-lightness--text'">favorite</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="px-3">
          <carousel 
            :loop="false" 
            :items="1" 
            :margin="10" 
            :center="true" 
            :dots="false" 
            :nav="false" 
            :class="`e-carousel--unidad cutypesix-${indexLesson}`" @changed="changed">
            <CardCarousel
              v-for="(lesson, index) in loadedLessons.options" :key="`textCaro-${index}`"
              :descripcion="lesson"
              :number="(index + 1)"
            />
          </carousel>
        </div>
      </v-card-text>
    </v-card>
</template>

<script>
import CardCarousel from '../intermedio/CardCarousel'

export default {
  name: 'CardCarouselFinal',
  components: {
    CardCarousel
  },
  props: {
    loadedLessons: {
        type: Object,
        default: {
            instructions_spanish: '',
            exercise: '',
            options: [],
            answer: ''
        }
    },
    indexLesson: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      correcto: false,
      itemActivo: 0
    }
  },
  methods: {
    seleccionarRespuesta(selected) {
      this.correcto = selected
      this.emitirRespuesta(this.correcto, this.itemActivo)
    },
    changed (data) {
      this.correcto = false
      this.itemActivo = data.item.index
      this.emitirRespuesta(this.correcto, this.itemActivo)
    },
    emitirRespuesta(selected, indexItem) {
      const soluciones = []
      if (selected) {
        soluciones.push(this.loadedLessons.options[indexItem])
      }
      const respuestaFinal = {
        answer: this.loadedLessons.answer,
        userAnswer: soluciones
      }
      this.$emit('clicked', respuestaFinal)
    }
  }
}
</script>